import { BaseModel } from './base.model'
import { CenterProgram } from './center-program.model'
import { CenterRepeatExamSetting } from './center-repeat-exam-setting.model'
import { Infraction } from './infraction.model'
import { Photo } from './photo.model'
import { CenterRegistrationSection } from './center-registration-section.model'
import { CenterOnlineLearningRepeatExamSetting } from './center-online-learning-repeat-exam-setting.model'
import { Constants } from 'config'
import { defaults } from 'lodash'
import { AppLocale } from './app-locale.model';
import { Hub } from './hub.model'
import { City } from './city.model'

export interface HubRedirectSetting {
  tariffName: string
  hubId: number
}

export interface CourseMapingSetting {
  tariffName: string
  course: string
}


export class Center extends BaseModel<Center> {
  
  static DEFAULT_ATTRIBUTES = {
    centerPrograms: [],
    images: [],
    infractionIds: [],
    infractions: [],
    mobile: false,
    default: false,
    schedule: Array.apply(null, Array(7)).map(() => { return { from: '09:00', to: '18:00' } }),
    repeatExamSettings: Array.from({ length: Constants.EXAMS.MAX_GRADE + 1 }, (value, key) => Constants.EXAMS.MIN_GRADE + key)
      .map(grade => new CenterRepeatExamSetting({ 
        grade, 
        enabled: true,
        daysCount: [0]
      }) 
    ),
    registrationSections: [],
    interviewInfractionIds: [],
    interviewInfractions: [],
    onlineLearningRetakeExamSettings: [],
    availableLocaleIds: [],
    hubRedirectSettings: [],
    courseMapingSettings: []
  }

  centerPrograms: CenterProgram[]
  repeatExamSettings: CenterRepeatExamSetting[]
  cityId: number
  cityName: string
  cityUtcOffset: number
  comment: string
  id: number
  images: Photo[]
  infractionIds: number[]
  infractions: Infraction[]
  mobile: boolean
  default: boolean
  name: string
  password: string
  schedule: Object[]
  state: string
  yandexName: string
  registrationSections: CenterRegistrationSection[]
  contactPersonId: number
  cropDriverPhoto: boolean
  interviewInfractionIds: number[]
  interviewInfractions: Infraction[]
  interviewCapacity: number
  onlineLearningRetakeExamSettings: CenterOnlineLearningRepeatExamSetting[]
  licenseAgreement: string
  licenseAgreementTitle: string
  availableLocales: AppLocale[]
  availableLocaleIds: number[]
  smsConfirmation: boolean
  hubRedirectSettings: HubRedirectSetting[]
  courseMapingSettings: CourseMapingSetting[]
  hubs: Hub[]
  city: City

  // 
  constructor(attributes: Object = {}) {
    super(attributes)
    this.courseMapingSettings = this.courseMapingSettings || this.constructor['DEFAULT_ATTRIBUTES']['courseMapingSettings']
    this.hubRedirectSettings = this.hubRedirectSettings || this.constructor['DEFAULT_ATTRIBUTES']['hubRedirectSettings']
    this.repeatExamSettings = defaults(this.repeatExamSettings, this.constructor['DEFAULT_ATTRIBUTES']['repeatExamSettings'])
    this.availableLocaleIds = this.availableLocales ? this.availableLocales.map(l => l.id) : []
  }

  removed(): boolean {
    return this.state == 'removed'
  }

  disabled(): boolean {
    return this.state == 'disabled'
  }

  programs(): number[] {
    return this.centerPrograms.map(cp => {
      if (cp.state == 'active')
        return cp.program.id
    })
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/center.model.ts